<template>
    <div class="flex w-full flex-col">
        <template v-if="!fetching">
            <h2 class="mb-4 text-2xl font-bold text-blue">
                Please wait while we redirect you to {{ label }}...
            </h2>
            <h2 class="text-lg font-bold text-blue">
                Please click below to be directed to {{ label }}...
            </h2>
            <HorizontalSeparator class="mb-4" />
            <span class="mb-4 text-lg">
                If the redirect has not happened within a second or two click...
            </span>

            <div class="flex w-full flex-col gap-4 md:w-2/5">
                <a :href="website" target="_blank">
                    <InputButton block style-type="contact-form">
                        Visit {{ label }}
                    </InputButton>
                </a>

                <InputButton block style-type="contact-form" @click="$emit('closeClick')">
                    Close this window<br />
                    and return to the listing of agencies
                </InputButton>

            </div>

            <div v-if="isDevMode()" class="mt-3 text-sm font-normal text-black">
                    {{ laravel_env }}/{{ isDevMode() }} Dev mode only: link built {{ website }}
            </div>

        </template>
        <template v-else>
            <h2 class="mb-4 text-2xl font-bold text-blue">
                One moment...
            </h2>
        </template>
        <div v-if="error">
            <h3 class="my-2 text-xl">Sorry, something went wrong</h3>
            <p> {{ errorMessage }}</p>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import InputButton from 'Components/InputButton';
import HorizontalSeparator from 'Components/HorizontalSeparator';
import AcCard from 'Components/AcCard';
import { mapMutations, mapState, mapGetters } from 'vuex';

export default {
    name: 'ContactSocialSuccess',
    components: { AcCard, HorizontalSeparator, InputButton },
    props: {
        agency: {
            type: Object,
        },
        branch: {
            type: Object,
        },
        socialType: {
            type: String,
        },
        userType: {
            type: String,
        },
    },
    data() {
        return {
            fetching: false,
            website: '',
            label: '',
            error: false,
            errorMessage: '',
            chosenBranch: null
        };
    },
    computed: {
        ...mapState('contact', ['isSkipped']),
    },
    methods: {
        ...mapMutations('contact', ['setIsSkipped']),
        openEntity() {
            if (this.website && !this.fetching) {
                const redirectDelay = 1250;
                console.log(`*** Opening ${this.website} in ${redirectDelay} ms`);
                window.setTimeout(() => {
                    window.open(this.website);
                }, redirectDelay);
            }
        }
    },
    async mounted() {
        if (!this.isSkipped) {
            this.$emit('registerContact');
        }
        switch (this.socialType) {
            case 'facebook': {
                this.website = `https://facebook.com/${this.agency.social_facebook}`;
                this.label = 'facebook';

                break;
            }
            case 'twitter': {
                this.website = `https://twitter.com/${this.agency.social_twitter}`
                this.label = 'twitter';

                break;
            }
            case 'mailto': {
                this.fetching = true;
                axios
                    .get(`/api/agencyTelfax/${this.agency.AgencyTag}`, {
                        params: {
                            userType: this.userType,
                            branch: this.branch.branch,
                        },
                    })
                    .then((response) => {
                        this.chosenBranch = response.data.data.chosenBranch;
                        this.website = `mailto:${this.chosenBranch.Email}`;
                        this.label = 'email editor';
                        this.fetching = false;
                        this.openEntity();
                    })
                    .catch((error) => {
                        this.error = true;
                        this.errorMessage = error.response.data.message;
                    })
                    .finally(() => {
                        this.setIsSkipped(false);
                    });
                break;
            }
        }

        await this.$nextTick();

        // twitter/facebook socials will just open, mailto we'll have to wait till axios completes.
        this.openEntity();

        this.setIsSkipped(false);
    },
};
</script>
